import React from 'react'
import { Card, Row, Col } from 'antd'
import { useNavigate } from 'react-router-dom'
import { ShoppingOutlined, PlusCircleOutlined, OrderedListOutlined, SettingOutlined } from '@ant-design/icons'
import Layout from '../components/layout/Layout'

function ManageStore() {
  const navigate = useNavigate()

  const actions = [
    {
      title: 'Add Products',
      icon: <PlusCircleOutlined style={{ fontSize: 36, color: '#52c41a' }} />,
      path: '/manageStore/addProducts',
      description: 'Add new items to your store',
    },
    {
      title: 'View Products',
      icon: <ShoppingOutlined style={{ fontSize: 36, color: '#1890ff' }} />,
      path: '/manageStore/viewProducts',
      description: 'See and manage all listed products',
    },
    {
      title: 'Order List',
      icon: <OrderedListOutlined style={{ fontSize: 36, color: '#722ed1' }} />,
      path: '/manageStore/storeOrders',
      description: 'Track and manage customer orders',
    },
    {
      title: 'Store Settings',
      icon: <SettingOutlined style={{ fontSize: 36, color: '#fa8c16' }} />,
      path: '/manageStore',
      description: 'Update store information and preferences',
    },
  ]

  return (
    <Layout>
      <h1 style={{ marginBottom: 24 }}>Manage Store</h1>
      <Row gutter={[24, 24]}>
        {actions.map((item, index) => (
          <Col xs={24} sm={12} md={8} lg={6} key={index}>
            <Card
              hoverable
              onClick={() => navigate(item.path)}
              style={{
                borderRadius: 12,
                textAlign: 'center',
                boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                transition: 'transform 0.2s',
              }}
              bodyStyle={{ padding: '24px 16px' }}
            >
              <div style={{ marginBottom: 12 }}>{item.icon}</div>
              <h3 style={{ marginBottom: 8 }}>{item.title}</h3>
              <p style={{ color: 'rgba(0,0,0,0.45)' }}>{item.description}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </Layout>
  )
}

export default ManageStore
